import * as React from 'react'

import { connect } from 'react-redux'
import { bindActionCreators, compose } from 'redux'
import { formValueSelector, InjectedFormProps, reduxForm } from 'redux-form'

import SnackbarService from '../../services/snackbars'

import * as UserActions from '../../store/user/actions'

import { RouteComponentProps, withRouter } from 'react-router'
import Content from './content'

interface INativeProps {}
interface IReduxStateProps {
  email: string
}

interface IReduxActionsProps {
  UserLib: any
}

interface IReduxProps extends IReduxStateProps, IReduxActionsProps {}
interface IProps
  extends INativeProps,
    IReduxProps,
    InjectedFormProps,
    RouteComponentProps {}
interface IState {
  loading: boolean
}

class ForgotPassword extends React.Component<IProps, IState> {
  state: IState = {
    loading: false
  }

  onSubmit = async () => {
    const { UserLib, email, history } = this.props
    UserLib.forgotPassword(
      email,
      () => {
        SnackbarService.showSnackbar(
          'We sent you an email with a reset password link',
          'info'
        )
        history.push('/login')
      },
      e => SnackbarService.showSnackbar(e, 'error')
    )
  }

  render() {
    const { history } = this.props
    const { loading } = this.state
    return (
      <Content history={history} loading={loading} onSubmit={this.onSubmit} />
    )
  }
}

const formConnector = reduxForm({ form: 'forgot-password' })
const selector = formValueSelector('forgot-password')

const mapStateToProps = (state): IReduxStateProps => ({
  email: selector(state, 'email')
})
const mapDispatchToProps = (dispatch): IReduxActionsProps => ({
  UserLib: bindActionCreators<any, any>(UserActions, dispatch)
})

const connector = connect(mapStateToProps, mapDispatchToProps)

const Connected = compose(formConnector, connector, withRouter)(ForgotPassword)

export default (props: INativeProps) => <Connected {...props} />



// WEBPACK FOOTER //
// ./src/pages/ForgotPassword/index.tsx